import { createBreadcrumbAPI, createBreadcrumbedEventChannel } from '../events/breadcrumbs';
import { createCatchingEventChannel } from '../events/core';
const breadcrumbAPI = createBreadcrumbAPI();
export const {
  breadcrumbMountedEventChannel,
  Breadcrumb,
  useGetBreadcrumbs
} = breadcrumbAPI;
export const externalGasV3UIEventChannel = createCatchingEventChannel();
export const externalGasV3ScreenEventChannel = createCatchingEventChannel();
export const externalGasV3TrackEventChannel = createCatchingEventChannel();
export const externalGasV3OperationalEventChannel = createCatchingEventChannel();
export const externalMetalChannel = createCatchingEventChannel();
export const externalSentryExceptionChannel = createCatchingEventChannel();
export const internalGasV3UIEventChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export const internalGasV3ScreenEventChannel = createCatchingEventChannel();
export const internalGasV3TrackEventChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export const internalGasV3OperationalEventChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export const internalMetalChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export const internalSentryExceptionChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);